module.exports = __webpack_public_path__ + "static/media/facebook-colored.cb6b87b9.svg";